import { z } from 'zod';
import { RoleType } from 'store/permissions';
import { clientAdminsFiltersSchema } from './admin-client-admins.schemas';

export const clientAdminStatuses = ['active', 'inactive'] as const;
export type ClientAdminStatus = (typeof clientAdminStatuses)[number];

export interface BaseClientAdmin {
  id: string;
  fullName: string;
  status: ClientAdminStatus;
  adminRole: {
    id: string;
    name: string;
    description: string;
    roleType: RoleType;
  };
  email: string;
  phone: string;
}

export interface ClientAdmin extends BaseClientAdmin {
  firstName: string;
  lastName: string;
  root: boolean;
}

export type ClientAdminsFilters = z.infer<typeof clientAdminsFiltersSchema>;
